import React from "react";
import useContent from "../../helpers/useContent";
import Content from "../../components/Content";
import Container from "../../components/Container";
import Stories from "../../components/Stories";
import Meta from "../../components/Meta";
import ExternalLinkList from "../../components/ExternalLinkList";
import DownloadBanner from "../../components/DownloadBanner";
import s from "./style.module.css";
import { useLocation } from "react-router-dom";
const {
  stories,
  banner,
  extra,
} = require(`../../pages/Homepage/copy/${process.env.REACT_APP_LANG}`);

const Header = ({ image, title }) => (
  <div className={s.header}>
    <Container>
      <h1 className={s.title}>{title}</h1>
      <img
        className={s.image}
        src={`${process.env.PUBLIC_URL}${image}`}
        alt=""
      />
    </Container>
  </div>
);

const Footnotes = ({ notes }, i) => (
  <ol>
    {notes.map((item, j) => (
      <li
        key={`footnote-${j}`}
        id={`footnote-${i}`}
        dangerouslySetInnerHTML={{ __html: item }}
      />
    ))}
  </ol>
);

const Story = ({
  id,
  meta = {},
  title,
  content,
  color,
  footnotes = [],
  children,
  relatedContent,
  additionalComponents,
}) => {
  const { pathname } = useLocation();
  const items = useContent(content, additionalComponents);

  const storyFromHome = stories.find((d) => d.id === id);

  const url =
    `${(process.env.DEPLOY_PRIME_URL || "https://wdr2021.worldbank.org")}${process.env.PUBLIC_URL}${pathname}`;



  return (
    <Meta {...meta} image={`/images/${id}/share.png`}>
      <div
        className={s.wrap}
        style={{
          "--bg": storyFromHome.colorSubtle,
        }}
      >
        {banner && <DownloadBanner {...banner} />}
        <Header image={`/images/${id}/header.svg`} title={title} />
        <Container>
          <div className={s.content}>
            {items.length !== 0 && (
              <div className={s.contentArea}>
                <Content items={items} />
              </div>
            )}

            {children && <div className={s.contentArea}>{children}</div>}

            {footnotes.length !== 0 && (
              <div className={s.contentArea}>
                <Footnotes notes={footnotes} />
              </div>
            )}
          </div>
        </Container>

        <div className={s.footer}>
          <Container large>
            <div className={s.inner}>
              <div className={s.related}>
                <ExternalLinkList
                  simple
                  title={extra.share}
                  inline
                  items={[
                    {
                      url: `https://www.twitter.com/intent/tweet?url=${url}`,
                      title: "Twitter",
                      icon: "twitter",
                    },
                    {
                      url: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                      title: "Facebook",
                      icon: "facebook",
                    },
                    {
                      url: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
                      title: "LinkedIn",
                      icon: "linkedin",
                    },
                  ]}
                />
              </div>

              <div className={s.related}>
                <ExternalLinkList
                  simple
                  title={extra.related}
                  items={relatedContent || []}
                />
              </div>
            </div>
          </Container>
        </div>

        <Stories id={id} />
      </div>
    </Meta>
  );
};

export default Story;
